import { TRIGGER_CONNECTION_NAME, TypedActorNode } from "./_Base";
import { NodeParamsConfig, ParamConfig } from "../utils/params/ParamsConfig";
import {
  ActorConnectionPoint,
  ActorConnectionPointType,
  ACTOR_CONNECTION_POINT_IN_NODE_DEF
} from "../utils/io/connections/Actor";
import { NodeContext } from "../../poly/NodeContext";
import { ALL_NOTES, DEFAULT_NOTE } from "../../../core/audio/Notes";
const CONNECTION_OPTIONS = ACTOR_CONNECTION_POINT_IN_NODE_DEF;
class PlayInstrumentNoteActorParamsConfig extends NodeParamsConfig {
  constructor() {
    super(...arguments);
    this.node = ParamConfig.NODE_PATH("", {
      nodeSelection: {
        context: NodeContext.AUDIO
      }
    });
    this.note = ParamConfig.STRING(DEFAULT_NOTE, {
      menuString: {
        entries: ALL_NOTES.sort().map((note) => {
          return { value: note, name: note };
        })
      },
      cook: false
    });
    this.duration = ParamConfig.FLOAT(0.125, {
      range: [0, 1],
      rangeLocked: [true, false],
      cook: false
    });
  }
}
const ParamsConfig = new PlayInstrumentNoteActorParamsConfig();
export class PlayInstrumentNoteActorNode extends TypedActorNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
  }
  static type() {
    return "playInstrumentNote";
  }
  initializeNode() {
    this.io.inputs.setNamedInputConnectionPoints([
      new ActorConnectionPoint(TRIGGER_CONNECTION_NAME, ActorConnectionPointType.TRIGGER, CONNECTION_OPTIONS),
      new ActorConnectionPoint(ActorConnectionPointType.OBJECT_3D, ActorConnectionPointType.OBJECT_3D, CONNECTION_OPTIONS)
    ]);
  }
  receiveTrigger(context) {
    var _a;
    const audioNode = this.pv.node.nodeWithContext(NodeContext.AUDIO, (_a = this.states) == null ? void 0 : _a.error);
    if (!audioNode) {
      return;
    }
    audioNode.compute().then((container) => {
      const audioBuilder = container.coreContent();
      if (!audioBuilder) {
        return;
      }
      const instrument = audioBuilder.instrument();
      if (!instrument) {
        return;
      }
      const note = this._inputValueFromParam(this.p.note, context);
      this._lastInstrumentType = instrument.triggerAttackRelease(note, this.pv.duration);
      this._lastNote = note;
    });
  }
  __lastInstrumentType() {
    return this._lastInstrumentType;
  }
  __lastNote() {
    return this._lastNote;
  }
}
